import { render } from "./HomeBanner.vue?vue&type=template&id=245f4fb8&scoped=true&ts=true"
import script from "./HomeBanner.vue?vue&type=script&lang=ts"
export * from "./HomeBanner.vue?vue&type=script&lang=ts"

import "./HomeBanner.vue?vue&type=style&index=0&id=245f4fb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245f4fb8"]])

export default __exports__